export interface RecursoRow {
    id: number
    tipo_id: number
    tipo_nombre: string
    nombre: string
    url: string
    estado_id: number
    fecha_creacion: string
    fecha_modificacion: string | null
    /**
     * Estación dueña del recurso (un recurso por estación). Opcionales para no
     * romper si todavía está publicada la versión anterior de
     * autoservicio.fnc_get_listado_recursos, que no los devolvía: la tabla solo
     * muestra la columna cuando llegan.
     */
    empresa_id?: number
    empresa_nombre?: string
}

/**
 * Datos técnicos del archivo, leídos en el navegador para mostrarlos en el
 * preview. No se envían al backend: `ancho`/`alto` y `duracion_segundos` pueden
 * faltar si el archivo no se pudo decodificar.
 */
export interface RecursoMetadata {
    nombre_archivo: string
    tipo_mime: string
    extension: string
    peso_bytes: number
    ancho?: number
    alto?: number
    duracion_segundos?: number
}

/**
 * Creación de recursos. Viaja como multipart/form-data a un único endpoint:
 * el backend guarda cada archivo en el storage y crea un recurso por cada uno
 * (la url la resuelve él, por eso no se envía).
 */
export interface RecursoCreateRequest {
    /**
     * Estaciones (empresas) donde se crea el recurso. El recurso se guarda una
     * sola vez por estación: ya no se replica por cada pos_config/pantalla.
     */
    empresa_ids: number[]
    tipo_id: number
    nombre: string
    estado_id?: number
    /** Uno o varios archivos: se crea un recurso por cada adjunto. */
    archivos: File[]
}

/**
 * Edición del recurso. También va como multipart al mismo endpoint: `archivo`
 * solo viaja cuando se reemplaza el actual y `url` es la que ya tenía (el
 * backend la conserva si no hay archivo nuevo).
 *
 * La estación no se edita: un recurso pertenece a la estación donde se creó. Si
 * hace falta en otra, se crea allá.
 */
export interface ActualizarRecursoRequest {
    id: number
    tipo_id: number
    nombre: string
    url: string
    estado_id: number
    archivo?: File
}

/**
 * Detalle que devuelve autoservicio.fnc_get_detalle_recurso al abrir el modal en
 * "editar" / "ver": trae la ubicación resuelta para mostrarla bloqueada.
 */
export interface RecursoDetalle {
    id: number
    tipo_id: number
    tipo_nombre: string
    nombre: string
    url: string | null
    estado_id: number
    empresa_id?: number
    empresa_nombre?: string
    regional_id?: number
    fecha_creacion: string
    fecha_modificacion: string | null
}

export const ESTADOS_RECURSO = {
    ACTIVO: 1,
    INACTIVO: 2,
} as const

export const TIPOS_RECURSO = {
    IMAGEN: 1,
    VIDEO: 2,
} as const


